import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../components/router/router-tabbed-navigation';
import { SweepPlanCreateDrawer } from '../../../../../../features/sweeps/plan/sweep-plan-create-drawer';
import { SweepPlansTable } from '../../../../../../features/sweeps/plan/sweep-plans-table';
import { useCanCreateSweepPlan } from '../../../../../../features/sweeps/sweeps-permission-helpers';
import { getPageHead } from '../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/sweep/plan/_plan/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.Sweeps,
      label: 'Plans',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.Sweeps>,
  head: () => getPageHead('Sweep Plans'),
  component: SweepPlanList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  const canCreateSweepPlan = useCanCreateSweepPlan();

  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {canCreateSweepPlan ? (
            <RequiresAccess write>
              <SweepPlanCreateDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Sweep Plan" size="small" />} />
            </RequiresAccess>
          ) : null}

          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.Sweeps}
    />
  );
}

function SweepPlanList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <SweepPlansTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
